import { render, staticRenderFns } from "./Forfeit.vue?vue&type=template&id=9f963028&"
import script from "./Forfeit.vue?vue&type=script&lang=js&"
export * from "./Forfeit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports